export const TOTAL_VOLUME_OF_ASSET_MAP: Record<string, string> = {
  '0': 'Below50000',
  '50000': '50000To99999',
  '100000': '100000To199999',
  '200000': '200000To499999',
  '500000': '500000To999999',
  '1000000': '1000000OrAbove',
};
